import { render, staticRenderFns } from "./PurchaseOrderDetails.vue?vue&type=template&id=30af1286&scoped=true"
import script from "./PurchaseOrderDetails.vue?vue&type=script&lang=ts"
export * from "./PurchaseOrderDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30af1286",
  null
  
)

export default component.exports